import { AxiosError } from "axios";

import { getUserInternalAccessToken } from "@/api/access-token-backoffice";
import { apiT2B } from "@/lib/axios";

const baseUserUrl = "/api/v1/user";

export async function getUserWithInternalAccess(data: { customerId: string; userId: number }) {
  try {
    const userId = data.userId;
    const customerId = data.customerId;

    // Obter token interno (backoffice), como no projeto legado
    const { accessToken: internalAccessToken } = await getUserInternalAccessToken();

    const response = await apiT2B.get(`${baseUserUrl}/${userId}`, {
      headers: {
        Authorization: `Bearer ${internalAccessToken}`,
        CustomerId: customerId,
      },
    });

    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || "Failed to fetch user");
    }
    throw new Error("Something went wrong");
  }
}
